"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseValidator = void 0;
var json_response_parser_1 = require("../json-response-parser");
var shouldResolveResponse = function (responseStatus, response) {
    return isSuccessResponse(responseStatus) ? Promise.resolve(response) : Promise.reject(response);
};
var isSuccessResponse = function (status) {
    var min = 200;
    var max = 300;
    return status >= min && status < max;
};
var validateResponse = function (response) {
    return response
        .text()
        .then(function (responseText) { return json_response_parser_1.jsonResponseParser.parse(responseText); })
        .then(function (responseBody) { return shouldResolveResponse(response.status, responseBody); });
};
exports.responseValidator = {
    validateResponse: validateResponse,
};
